// Reviews: reveal the cards held back behind "See more".
//
// Desktop is height-based, not count-based: the brickwork columns are capped to
// a set height (--rv-collapsed-height) and fill top to bottom, so how many cards
// show depends on how big they are. Anything that falls past the cap sits in an
// extra, clipped column until "See more" lifts the cap. Mobile keeps a simple
// card count, because two narrow columns fill the screen far sooner.

const MOBILE = '(max-width: 749px)';

function initReviews(root) {
  if (root.dataset.reviewsInit) return;
  root.dataset.reviewsInit = '1';

  const toggle = root.querySelector('[data-reviews-toggle]');
  const label = root.querySelector('[data-reviews-toggle-label]');
  const grid = root.querySelector('.rv__grid');
  if (!toggle || !grid) return;

  const cards = Array.prototype.slice.call(root.querySelectorAll('.rv__item'));
  const mobileCount = parseInt(root.dataset.visibleCountMobile || '4', 10);
  const moreLabel = toggle.dataset.labelMore || 'See more reviews';
  const lessLabel = toggle.dataset.labelLess || 'Show fewer';

  const mq = window.matchMedia(MOBILE);
  let expanded = false;
  let desktopHasMore = false;

  function apply() {
    const mobile = mq.matches;

    // Mobile: hide by count. Desktop: never hide by count.
    cards.forEach(function (el, i) {
      el.classList.toggle('rv__item--hidden', mobile && !expanded && i >= mobileCount);
    });

    // Desktop: cap the height while collapsed, then see whether anything is
    // clipped. A clipped card lives in an extra column, so the grid is wider
    // than what is visible.
    root.classList.toggle('rv--collapsed', !mobile && !expanded);
    if (!mobile && !expanded) {
      desktopHasMore = grid.scrollWidth > grid.clientWidth + 2;
    }

    const hasMore = mobile ? cards.length > mobileCount : desktopHasMore;
    toggle.hidden = !hasMore;
    toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    if (label) label.textContent = expanded ? lessLabel : moreLabel;
  }

  toggle.addEventListener('click', function () {
    expanded = !expanded;
    apply();
    if (!expanded) {
      const top = root.getBoundingClientRect().top;
      if (top < 0) root.scrollIntoView({ block: 'start' });
    }
  });

  // Crossing the breakpoint changes how reviews are held back.
  if (mq.addEventListener) mq.addEventListener('change', apply);
  else if (mq.addListener) mq.addListener(apply);

  // Photos loading and window resizes change card heights, so re-measure.
  let timer;
  function later() {
    clearTimeout(timer);
    timer = setTimeout(apply, 120);
  }
  window.addEventListener('resize', later);
  window.addEventListener('load', later);
  grid.querySelectorAll('img').forEach(function (img) {
    if (!img.complete) img.addEventListener('load', later, { once: true });
  });

  apply();
}

function bootReviews(scope) {
  (scope || document).querySelectorAll('[data-reviews]').forEach(initReviews);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () {
    bootReviews();
  });
} else {
  bootReviews();
}

document.addEventListener('shopify:section:load', function (e) {
  bootReviews(e.target);
});
